import { calculateROI } from "@/shared/utils/calculateROI";

/**
 * Returns a function that calculates the maximum ROI and tracks the spend
 * that yielded the maximum ROI.
 * @returns A function that takes spend and revenue, updates the max ROI, and returns the spend with max ROI.
 */
export function calculateMaxEfficiency() {
  let maxROI = -Infinity;
  let maxROISpend = 0;

  return (spend: number, revenue: number): number => {
    // Calculate the ROI using the provided utility function
    const roi = calculateROI(spend, revenue);

    // Update max ROI and corresponding spend if the current ROI is greater
    if (roi !== null && roi > maxROI) {
      maxROI = roi;
      maxROISpend = spend;
    }

    // Return the spend that had the maximum ROI
    return maxROISpend;
  };
}
